var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreyWhiteRectangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1440,
    height: 96,
    fill: "none",
    viewBox: "0 0 1440 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F6",
    d: "M1442.16 96L.071.278H1442.16V96z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyWhiteRectangle);
export default __webpack_public_path__ + "static/media/GreyWhiteRectangle.bca84c5daeb4d431f60c42134ab2c329.svg";
export { ForwardRef as ReactComponent };